/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Listbox } from '@headlessui/react';
import styled from 'styled-components';
import { white, ink2, tintsBlue, brandBlueDark, charcoal2, pebble2, blueberryHover } from '../../styles/shared/colors';
import { respondTo } from '../../styles/shared/breakpoints';
import {leftArrow} from '../../assets/images/leftArrow.svg'
const ListboxContainer = styled.div`
  height: auto;

  ${respondTo.md`
    margin-right: 20px;
    display:inline-block;
    position:relative;
    // display: flex;
    // flex-direction: column;
    // height: 50px;
    
    cursor: pointer;
  `}

  ul {
    z-index: 1;
        position: absolute;
    width: 100%;
    li {
      border-top: 0.5px solid ${pebble2};

      background: ${white};

      color: ${brandBlueDark};

      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      padding: 15px 10px 15px 10px;

      &:after {
        content: url("data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='Link arrow - internal'%3E%3Cpath id='Vector' d='M8 0.015625C3.5816 0.015625 0 3.59763 0 8.01562C0 12.4336 3.5816 16.0156 8 16.0156C12.4184 16.0156 16 12.434 16 8.01562C16 3.59722 12.4184 0.015625 8 0.015625ZM8.5492 11.8152C8.32 12.0548 7.9404 12.0628 7.7008 11.834C7.4612 11.6048 7.4532 11.2252 7.682 10.9856L9.95 8.61562H4.4364C4.1052 8.61562 3.8364 8.34682 3.8364 8.01562C3.8364 7.68442 4.1052 7.41562 4.4364 7.41562H9.95L7.682 5.04562C7.4528 4.80603 7.4612 4.42643 7.7008 4.19723C7.94 3.96803 8.32 3.97643 8.5492 4.21603L12.1852 8.01562L8.5492 11.8152Z' fill='%232E3790'/%3E%3C/g%3E%3C/svg%3E%0A");
        float: right;
      }

      ${respondTo.md`
        color: ${ink2};
        border-bottom: 0.5px solid rgba(0, 0, 0, 0.40);
        border-radius: 5px;
        box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
        height: 34px;
        padding: 5px 10px 5px 10px;
        margin-top: 2px;

        &:hover {
          background: ${tintsBlue};
        }

        &:after {
          content: '';
          float: unset;
        }
  
      `}
    }
  }

  .change-button {
    ${respondTo.md`
      display: none;  
    `};
   background: ${white};
  color: ${blueberryHover};
  border: 0px;
  border-radius: 3px;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 13;

  margin-right: 20px;
  margin-left: auto;  }
    
  .indication-dropdown {
        
  
    background: transparent;
    border: 0px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    color: #FFF;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 20.8px;

  ${respondTo.md`
    
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid ${white};
    background: transparent;
    padding: 5px 7px 5px 7px;
    width: 230px;
    height: 34px;
    text-align: left;
    font-size: 18px;
    color: ${white};
    `}
    

    &:hover {
    }

    &:after {
      content: "";
      float: right;
      margin-top: 2px;
    }

    &[data-state="true"].main {
      display: none;
    }

    &.back {
      display: inline-block;
      height: unset;
      border: unset;
      border-radius: unset;

      background: ${white};

      color: ${charcoal2};
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;

      width: 100%;
      margin-left: 0px;
      padding: 0px 10px 15px 10px;

      &:after {
        content: url("data:image/svg+xml,%3Csvg width='9' height='15' viewBox='0 0 9 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='Components/Icons/Simple/Carat-Left'%3E%3Cpath id='Vector' d='M3.30726e-05 7.50014L6.3872 14.1747C6.78983 14.5956 7.45664 14.6096 7.87754 14.2077C8.29843 13.8051 8.31248 13.1383 7.91056 12.7174L2.82697 7.50014L7.91056 2.2829C8.31318 1.86201 8.29843 1.19519 7.87754 0.792564C7.45735 0.389942 6.78983 0.4047 6.3872 0.825591L3.30726e-05 7.50014Z' fill='%232E3790'/%3E%3C/g%3E%3C/svg%3E%0A");
        float: left; 
        margin-right: 21px;
      }
    }

    ${respondTo.md`
      
      &.main:after {
        transform: rotate(0deg);
        transform-origin: center;
        margin-top: 2px;
        height: 20px;
      }

      &[data-headlessui-state="open"].main, &[data-state="true"].main{
        display: unset;
        flex-direction: row-reverse;
        display: flex;
        justify-content: flex-end;
        column-gap: 5.5px;
        background: ${blueberryHover};
      }

      &[data-state="false"].main:after{
        transform: rotate(0deg);
      }

      &[data-state="true"].main:after{
        transform: rotate(180deg);
      }

      &.main {
      
        display: unset;
        flex-direction: row-reverse;
        display: flex;
        justify-content: flex-end;
        column-gap: 5.5px;
      }

      &.back {
        display: none;
      }

      &:after {
        content: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='graphic-arrows'%3E%3Cpath id='Mask' d='M9.81322 13.727L4.2865 8.46079C3.9045 8.09681 3.9045 7.50823 4.2865 7.14811L5.20491 6.27299C5.5869 5.909 6.2046 5.909 6.58253 6.27299L10.5 10.0058L14.4175 6.27299C14.7995 5.909 15.4172 5.909 15.7951 6.27299L16.7135 7.14811C17.0955 7.5121 17.0955 8.10068 16.7135 8.46079L11.1868 13.727C10.8129 14.091 10.1952 14.091 9.81322 13.727Z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/svg%3E");
      }
    `}
  }
    
`

// eslint-disable-next-line react/prop-types
const NavigationDropDown = ({ offsetTop, handleIndicationDropdownChange, navItem, pageKey, onClose }) => {
   
  const [dropdownState, setDropdownState] = useState(null);
  const [selectedCondition, setSelectedCondition] = useState(null);

  // Load selected condition from session storage on component mount
  useEffect(() => {
    const savedCondition = sessionStorage.getItem('selectedCondition');
    if (savedCondition) {
      setSelectedCondition(savedCondition);
    }
  }, []);

  // Set default text based on selected condition or pageKey
  let DropdownDefaultText = selectedCondition || (pageKey === 'rcc' ? 'Advanced RCC' : pageKey === 'vhl' ? 'VHL Disease' : navItem.label);

  const handleDropdown = (e) => {
    e.preventDefault();
    setDropdownState(!dropdownState);
  };

  const handleOptionSelect = (condition, redirectPath) => {
    // Store the selected condition in session storage
    sessionStorage.setItem('selectedCondition', condition);
  
    // Update the dropdown text with the selected condition
    setSelectedCondition(condition);
  
    // Call the change handler if needed
    handleIndicationDropdownChange(condition);
  
    // Close the dropdown
    onClose();
  
    // Get the base URL
    const baseUrl = window.location.origin;
  
    // Ensure redirectPath is defined and valid
    if (redirectPath) {
      // Get the current path
      const currentPath = window.location.pathname;
  
      // Determine if we need to redirect
      if (condition === 'Advanced RCC' && currentPath.includes('advanced-renal-cell-carcinoma')) {
        // Redirect to the same path if already on the RCC page
        window.location.href = `${baseUrl}/advanced-renal-cell-carcinoma/`;
      } else if (condition === 'VHL Disease' && currentPath.includes('von-hippel-lindau')) {
        // Redirect to the same path if already on the VHL page
        window.location.href = `${baseUrl}/von-hippel-lindau/`;
      } else {
        // Redirect to the specified path if not on the correct page
        window.location.href = `${baseUrl}/${redirectPath}`;
      }
    } else {
      console.error('Redirect path is undefined or invalid');
    }
  };
  



  const ModalWrapper = styled.div`
    background: linear-gradient(90deg, #2148a3 0%, #3077e2 100%);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    position: fixed;
    // top: 52px; // if present onetrust-banner-sdk this css
    // top: 0; // if onetrust-banner-sdk NOT present this css
    top: ${(props) => `${props.offsetTop}px`};
    left: 0;
    width: 100%;
    height: 100%;

    ${respondTo.md`
      height: fit-content;
      // top: 90px; // if present onetrust-banner-sdk this css
      // top: 52px;// if onetrust-banner-sdk NOT present this css
      top: ${(props) => `${props.offsetTop}px`};
    `}

    z-index: 1000;
    
    cursor: auto;
    pointer-events: auto;
  `
  // Modal Content
const ModalContent = styled.div`
  padding: 2rem;
  text-align: center;
  width: 100%;
  max-width: 800px;
  position: relative;

  ${respondTo.md`
    width: 80%  
  `}
   
`;

// Close Button
const CloseButton = styled.button`
position: absolute;
top: 20px;
right: 20px;
background: transparent;
border: none;
font-size: 24px;
color: white;
cursor: pointer;

${respondTo.sm`
  display:none;
  `}

`;

// Title
const Title = styled.h2`
color: #FFF;
text-align: center;
font-family:  inherit;
font-size: 28px;
font-style: normal;
font-weight: 800;
line-height: 36.4px;

  @media (min-width: 768px) {
    margin-top: 0; /* mt-md-0 */
  }

  @media (min-width: 992px) {
    margin-top: 0; /* mt-lg-0 */
    margin-bottom: 1.5rem; /* mb-lg-4 */
  }
    &.spacer-24--b_mob {
    margin-bottom: 1.5rem; /* You can adjust based on the spacer-24--b_mob class */
  }
`;

// Button container
const ButtonContainer = styled.div`
display: flex;
justify-content: center;
flex-direction: column;
    gap: 20px;
color: #2E3790;
font-family:  inherit;
font-size: 11px;
font-style: normal;
font-weight: 700;
line-height: 23.4px;

font-size: 11px;
font-style: normal;
font-weight: 700; 


${respondTo.md`
flex-direction: row;
`}

`;

// Individual buttons
const OptionButton = styled.button`

display: flex;
background: white;
border: none;
padding: 1rem 2rem;
border-radius: 8px;
font-size: 1rem;
color: #2148a3;
cursor: pointer;
width: 45%;

font-family: inherit;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 130%; /* 23.4px */

display: flex!important;
width: 293px;
padding: 20px 15px 20px 20px;
align-items: center;
gap: 30px;
flex-shrink: 0;

    justify-content: space-between;

&:hover {
  background: #f0f0f0;
}

&::after {
  content: ${leftArrow};
  float: right;
  font-size: 1.2rem;
}

color: #2C3796; 
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 130%; /* 23.4px */
`;




return (
  <ListboxContainer>
      <Listbox onChange={handleIndicationDropdownChange}>
        <Listbox.Button
          onClick={handleDropdown}
          className="indication-dropdown main"
          data-state={dropdownState}
        >
          <span>{DropdownDefaultText}</span>
          <button className="change-button">Change</button>
        </Listbox.Button>

        {dropdownState && (
          <>
            <div>
              <Listbox.Options static>
                <ModalWrapper >
                  <ModalContent>
                    <CloseButton onClick={onClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">
<path d="M13.2925 11.0107L10.7845 8.5L13.2934 5.98837L16.5249 2.76354C17.1584 2.13144 17.1584 1.10617 16.5249 0.474071C15.8915 -0.158024 14.8641 -0.158024 14.2307 0.474071L8.49999 6.2123L2.76928 0.474071C2.13587 -0.158024 1.10846 -0.158024 0.475056 0.474071C-0.158352 1.10617 -0.158352 2.13144 0.475056 2.76354L3.70658 5.98837L6.21548 8.5L3.70747 11.0107L0.475056 14.2364C-0.158352 14.8685 -0.158352 15.8938 0.475056 16.5259C1.10846 17.158 2.13587 17.158 2.76928 16.5259L8.49999 10.7877L14.2307 16.5259C14.8641 17.158 15.8915 17.158 16.5249 16.5259C17.1584 15.8938 17.1584 14.8685 16.5249 14.2364L13.2925 11.0107Z" fill="white" />
</svg>

                    </CloseButton>
                    <Title className="spacer-24--b_mob">Select a condition</Title>
                    <ButtonContainer>
                      <OptionButton onClick={() => handleOptionSelect('Advanced RCC', 'advanced-renal-cell-carcinoma/')}>
                        Advanced RCC
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <path d="M11.2898 1.39774C10.7407 0.823767 9.83135 0.804605 9.25738 1.35271C8.6834 1.90177 8.66424 2.81112 9.21235 3.38509L14.6455 9.06256H1.43733C0.643925 9.06256 0 9.70648 0 10.4999C0 11.2933 0.643925 11.9372 1.43733 11.9372H14.6455L9.21235 17.6147C8.66328 18.1887 8.6834 19.098 9.25738 19.6471C9.83039 20.1961 10.7407 20.176 11.2898 19.602L20 10.4999L11.2898 1.39774Z" fill="#2E3790"/>
</svg>
                      </OptionButton>
                      <OptionButton onClick={() => handleOptionSelect('VHL Disease', 'von-hippel-lindau/')}>
                        VHL Disease
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <path d="M11.2898 1.39774C10.7407 0.823767 9.83135 0.804605 9.25738 1.35271C8.6834 1.90177 8.66424 2.81112 9.21235 3.38509L14.6455 9.06256H1.43733C0.643925 9.06256 0 9.70648 0 10.4999C0 11.2933 0.643925 11.9372 1.43733 11.9372H14.6455L9.21235 17.6147C8.66328 18.1887 8.6834 19.098 9.25738 19.6471C9.83039 20.1961 10.7407 20.176 11.2898 19.602L20 10.4999L11.2898 1.39774Z" fill="#2E3790"/>
</svg>
                      </OptionButton>
                    </ButtonContainer>
                  </ModalContent>
                </ModalWrapper>
              </Listbox.Options>
            </div>
          </>
        )}
      </Listbox>
    </ListboxContainer>
);
};

export default NavigationDropDown;